import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import "./Login.vue?vue&type=style&index=0&id=914cabe2&scoped=true&lang=css"
script.__scopeId = "data-v-914cabe2"

export default script